import styled from "styled-components";
import SwiperCore, { EffectCoverflow, Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { device } from "../../styles/device";
import Device from "../global/Device/Device";
import FeaturedPostTile from "./FeaturedPostTile";

const FeaturesSectionContainer = styled.section`
  background-color: #161617;
  color: #fff;
  overflow: hidden;
  padding-top: 80px;
  padding-bottom: 80px;
  margin-top: 64px;

  h2 {
    margin-top: 0;
    color: #fff;
    font-size: 24px;
    font-weight: 700;

    @media ${device.tablet} {
      font-size: 32px;
    }
  }
`;

const FeaturesSectionContent = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 365px;
  max-width: 100%;
  @media ${device.tablet} {
    width: 692px;
  }
  @media ${device.laptop} {
    width: 1080px;
  }
`;
const FeaturesSectionSwiperContent = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const SwiperWrapper = styled.div`
  .swiper {
    width: 100%;
    padding-top: 0;
    padding-bottom: 50px;

    overflow: visible;
    margin-left: auto;
    margin-right: auto;
    width: 365px;
    @media ${device.tablet} {
      width: 692px;
    }
    @media ${device.laptop} {
      width: 1080px;
    }
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 365px;
    height: 458px;

    @media ${device.tablet} {
      width: 692px;
      height: 389px;
    }

    @media ${device.laptop} {
      width: 1080px;
      height: 580px;
    }
  }

  .swiper-slide img {
    display: block;
    width: 100%;
  }

  .swiper-pagination-bullet-active {
    background: #f5f5f7 !important;
  }
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets
    .swiper-pagination-bullet {
    background-color: #6e6e73;
  }
  .swiper-button-next,
  .swiper-button-prev {
    height: 44px;
    width: 44px;
    text-align: center;
    bottom: -10px;
    top: initial;
  }

  .swiper-button-next:after,
  .swiper-button-prev:after {
    height: 15px;
    width: 15px;
    font-size: 16px;
    font-weight: 800;
  }

  .swiper-button-next,
  .swiper-rtl .swiper-button-prev {
    right: 25px;
    color: #ffffff;
    border: 2px solid #fff;
    border-radius: 50%;
  }
  .swiper-button-prev,
  .swiper-rtl .swiper-button-next {
    left: 25px;
    color: #ffffff;
    border: 2px solid #fff;
    border-radius: 50%;
  }
`;

SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

export const FeaturedSection = ({ posts }) => {
  return (
    <FeaturesSectionContainer>
      <FeaturesSectionContent>
        <h2>Vorgestellte Stories</h2>
      </FeaturesSectionContent>
      <FeaturesSectionSwiperContent>
        <SwiperWrapper>
          <Device>
            {({ isMobile }) => (
              <Swiper
                effect={"coverflow"}
                grabCursor={true}
                centeredSlides={true}
                pagination={{ clickable: true, dynamicBullets: true }}
                navigation={true}
                cssMode={isMobile}
                slidesPerView={"auto"}
                coverflowEffect={{
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: true,
                }}
                className="mySwiper"
              >
                {posts.map(({ node }) => (
                  <SwiperSlide key={"SwiperSlide-" + node.slug}>
                    <FeaturedPostTile
                      key={node.slug}
                      title={node.title}
                      coverImage={node.featuredImage?.node}
                      date={node.date}
                      author={node.author?.node}
                      slug={node.slug}
                      excerpt={node.excerpt}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </Device>
        </SwiperWrapper>
      </FeaturesSectionSwiperContent>
    </FeaturesSectionContainer>
  );
};
